import { ITextFieldProps, ITextFieldStyles, TextField } from "@fluentui/react";
import { useId } from '@fluentui/react-hooks';
import {ThemeContext} from '@fluentui/react-theme-provider';
import React, { useContext } from 'react';
import styled from 'styled-components';
import {ModalRefund} from './ModalRefund';

export interface Props extends ITextFieldProps
{
    placeholder: string,
    buttonTitle: string,
    valueRefund: string,
    /** Si true, no se muestra el botón Establecer (solo el input). Evita usar un carácter falso cuando el campo está vacío. */
    hideButton?: boolean,
    onChange?: (event: React.FormEvent | null, name?: string, value?: string, required?: boolean) => void;
    handleRefund: (refund: string) => void
};

export const DivInputElement = styled.div`
    > div
    {
        width: 100%;
        min-Height: 80px !important;

        > div
        {
            width: 70% !important;
        }

        #divButton
        {
            width: 20% !important;
        }
    }
`;
const stylesPassword: Partial<ITextFieldStyles> =
{
    revealButton:
    {
        backgroundColor: "transparent !important",
        paddingTop: "10px"
    }
};

const InputRefundsButton :  React.FC<Props> = (props: Props) =>
{
    const inputId = useId();
    const theme = useContext(ThemeContext);
    const {placeholder, valueRefund, hideButton, onChange, handleRefund, errorMessage, label, name, required, disabled, type, canRevealPassword} = props;

    const handleRefundFromModal = (_event: React.FormEvent | null, value: string): void =>
    {
        handleRefund(value);
    };

    const textFieldValue = valueRefund ?? "";
    const handleTextFieldChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string): void =>
    {
        const val = newValue ?? "";
        onChange?.(null, name, val, required);
    };

    const textField =
    (
        <TextField styles={stylesPassword} id={inputId} autoComplete="off"
            name={name} type={type} canRevealPassword={canRevealPassword} disabled={disabled}
            required={required} errorMessage={errorMessage} label={label} placeholder={placeholder}
            value={textFieldValue} onChange={handleTextFieldChange}
        />
    );

    const showOnlyTextField = hideButton === true || textFieldValue !== "";
    if(!showOnlyTextField)
    {
        return(
            <DivInputElement theme={theme}>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col" style={{width: "70% !important"}}>
                        {textField}
                    </div>
                    <div className="ms-Grid-col" id="divButton" style={{minHeight: "90px !important", width: "20% !important"}}>
                        <ModalRefund onChange={handleRefundFromModal} />
                    </div>
                </div>
            </DivInputElement>
        );
    }

    return textField;
}

export default InputRefundsButton;